export default __webpack_public_path__ + "static/media/f6.a3b1e220.svg";